<template>
  <main class="sideBar">
    <div class="logo-container">
      <Logo/>
    </div>
    <div class="filterSelection">
      <VueDatePicker @closed="this.sendFilters()" v-model="date" range multi-calendars locale="fr-FR" :enable-time-picker="false" :format="formatDate" position="right" auto-apply required :teleport="true" :preset-dates="presetDates" class="mb-3">
        <template #preset-date-range-button="{ label, value, presetDate }">
          <span 
              role="button"
              :tabindex="0"
              @click="presetDate(value)"
              @keyup.enter.prevent="presetDate(value)"
              @keyup.space.prevent="presetDate(value)">
            {{ label }}
          </span>
        </template>
      </VueDatePicker>
      <div class="filter-container mb-3">
        <input name="sda" role="combobox" list="" class="form-control" @focus="sdaInputFocused = true; selectedSda = ''" @blur="handleBlur" v-model="selectedSda" placeholder="Sélectionnez une SDA" autocomplete="off" type="search"/>
        <datalist class="sideBar" id="sda" role="listbox" :style="{display: sdaInputFocused ? 'block' : 'none'}">
          <option v-for="(sda, index) in filteredSdaList" :key="index" @click="selectSda(sda.calledLine)">{{ sda.calledLine }}</option>
        </datalist>
      </div>
      <div class="filter-container mb-3">
        <input name="callGroup" role="combobox" list="" class="form-control" @focus="callGroupInputFocused = true; selectedCallGroup = ''" @blur="handleBlur" v-model="selectedCallGroup" placeholder="Sélectionnez un Groupe d'appel" autocomplete="off" type="search"/>
        <datalist class="sideBar" id="callGroup" role="listbox" :style="{display: callGroupInputFocused ? 'block' : 'none'}">
          <option v-for="(callGroup, index) in filteredCallGroupList" :key="index" @click="selectCallGroup(callGroup.queue)">{{ callGroup.queue }}</option>
        </datalist>
      </div>
      <div class="filter-container mb-3">
        <input name="agent" role="combobox" list="" class="form-control" @focus="agentsInputFocused = true; selectedAgentDisplay = ''; selectedAgent = ''" @blur="handleBlur" v-model="selectedAgentDisplay" placeholder="Sélectionnez un Agent" autocomplete="off" type="search"/>
        <datalist class="sideBar" id="agent" role="listbox" :style="{display: agentsInputFocused ? 'block' : 'none'}">
          <option v-for="(agent, index) in filteredAgentsList" :key="index" @click="selectAgent(agent.Agent, agent.contactName)">{{ agent.contactName }}</option>
        </datalist>
      </div>
    </div>
    <div class="navigation-container">
      <h6>Navigation</h6>
      <router-link to="/dashboard" class="link">
        <font-awesome-icon icon="fa-solid fa-chart-pie" />
        Tableau de bord
      </router-link>
      <router-link to="/callsManager" class="link">
        <font-awesome-icon icon="fa-solid fa-phone" />
        Gestionnaire d'appels
      </router-link>
      <router-link to="/CallsHandling" class="link" v-if="dataStore.api.api3cx">
        <font-awesome-icon icon="fa-solid fa-signal" />
        Flux entrants
      </router-link>
      <router-link to="/CallsDetails" class="link" v-if="dataStore.api.api3cx">
        <font-awesome-icon icon="fa-solid fa-phone-volume" />
        Détails des appels
      </router-link>
      <router-link to="/agentManager" class="link" v-if="!limitedSda">
        <font-awesome-icon icon="fa-solid fa-users" />
        Gestionnaire d'agents
      </router-link>
      <router-link to="/timeManager" class="link" v-if="!limitedSda">
        <font-awesome-icon icon="fa-solid fa-clock" />
        Gestion du temps
      </router-link>
    </div>
    <div class="navigation-container" v-if="!limitedSda">
      <h6>Paramètres</h6>
      <router-link to="/users" class="link">
        <font-awesome-icon icon="fa-solid fa-users-cog" />
        Gestion des utilisateurs
      </router-link>
      <router-link to="/reports" class="link">
        <font-awesome-icon icon="fa-solid fa-envelope" />
        Gestion des Rapports
      </router-link>
      <!-- <router-link to="/support" class="link">
        <svg viewBox="64 64 896 896" focusable="false" data-icon="question-circle" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"></path><path d="M623.6 316.7C593.6 290.4 554 276 512 276s-81.6 14.5-111.6 40.7C369.2 344 352 380.7 352 420v7.6c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V420c0-44.1 43.1-80 96-80s96 35.9 96 80c0 31.1-22 59.6-56.1 72.7-21.2 8.1-39.2 22.3-52.1 40.9-13.1 19-19.9 41.8-19.9 64.9V620c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-22.7a48.3 48.3 0 0130.9-44.8c59-22.7 97.1-74.7 97.1-132.5.1-39.3-17.1-76-48.3-103.3zM472 732a40 40 0 1080 0 40 40 0 10-80 0z"></path></svg>
        Support
      </router-link> -->
    </div>
    <div class="navigation-container">
      <!-- <h6>Utilitaire</h6> -->
      <router-link to="/dc" class="link">
        <font-awesome-icon icon="fa-solid fa-power-off" />
        Déconnexion
      </router-link>
    </div>
  </main>
</template>

<script>
// all theses icons come from ant-design
import store from '@/store'
import Logo from '@/components/Logo.vue'
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'

export default {
  name: 'SideBar',
  components: {
    Logo,
    VueDatePicker
  },
  props: {

  },
  watch: {
    selectedSda (newVal) {
      // change Sda list
      if(newVal != '') {
        this.filteredSdaList = this.sdaList.filter(elem => elem.calledLine.toLowerCase().includes(newVal.toLowerCase()))
      }
      else {
        this.filteredSdaList = this.sdaList
      }
    },
    selectedCallGroup (newVal) {
      // change queue list
      if(newVal != '') {
        this.filteredCallGroupList = this.callGroupList.filter(elem => elem.queue.toLowerCase().includes(newVal.toLowerCase()))
      }
      else {
        this.filteredCallGroupList = this.callGroupList
      }
    },
    selectedAgentDisplay (newVal) {
      // change agent list
      if(newVal != '') {
        this.filteredAgentsList = this.agentsList.filter(elem => elem.contactName.toLowerCase().includes(newVal.toLowerCase()))
      }
      else {
        this.filteredAgentsList = this.agentsList
      }
    },
    selectedAgent () {
      this.sendFilters()
    },
    optionIsClicked () {
      setTimeout(() => {
        this.optionIsClicked = false;
      }, 500)
    }
  },
  data () {
    return {
      date: [
        new Date(new Date().getTime() - 7 * 24 * 60 * 60 * 1000),
        new Date()
      ],
      // ------------------------------
      sdaInputFocused: false,
      filteredSdaList: [],
      sdaList: [],
      selectedSda: '',
      // ------------------------------
      callGroupInputFocused: false,
      filteredCallGroupList: [],
      callGroupList: [],
      selectedCallGroup: '',
      // ------------------------------
      agentsInputFocused: false,
      filteredAgentsList: [],
      agentsList: [],
      selectedAgent: '',
      selectedAgentDisplay: '',
      // ------------------------------
      optionIsClicked: false,
      dataStore: store,
      limitedSda: null
    }
  },
  computed: {
    presetDates () {
      let today = new Date();
      let firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
      let lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);

      let firstOfWeek = today.getDate() - today.getDay() + 1; // First day is the day of the month - the day of the week. + 1 because day[0] is Sunday and i want monday
      let lastOfWeek = firstOfWeek + 6; // last day is the first day + 6
      let firstDayOfWeek = new Date(new Date(today).setDate(firstOfWeek))
      let lastDayOfWeek = new Date(new Date(today).setDate(lastOfWeek))

      // let lastOfLastWeek = new Date(today).setTime(today.getTime() - 6 * 24 * 60 * 60 * 1000);
      // let firstOfLastWeek = new Date(today).setTime(today.getTime() - (today.getDay() ? today.getDay() : 7) * 24 * 60 * 60 * 1000);

      const sevenDaysAgo = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)

      return [
        { label: 'Aujourd\'hui', value: [new Date(), new Date()] },
        {
          label: '7 jours glissants',
          value: [sevenDaysAgo, new Date()],
          // slot: 'preset-date-range-button'
        },
        { label: 'Cette semaine', value: [firstDayOfWeek, lastDayOfWeek] },
        // {
        //   label: 'Semaine dernière',
        //   value: [firstOfLastWeek, lastOfLastWeek],
        // },
        { label: 'Ce mois-ci', value: [firstDayOfMonth, lastDayOfMonth] },
        { label: 'Mois dernier', value: [new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1), new Date(new Date().getFullYear(), new Date().getMonth(), 0)] },
        { label: 'Cette année', value: [new Date(new Date().getFullYear(), 0, 1), new Date()] },
        { label: '365 jours glissants', value: [new Date(new Date().setDate(new Date().getDate() - 364)), new Date()] }
      ]
    }
  },
  methods: {
    presetDate (value) {
      this.date = value
    },
    getFilterData () {
      let url = this.$baseUrl+'/api/sda'
      this.limitedSda = JSON.parse(localStorage.getItem('userData')).BoundSda
      if(this.limitedSda) {
        url += '?limitedSda=' + this.limitedSda
      }
      fetch(url, {
        method: 'GET',
        headers: {
          authorization: 'Basic '+btoa(`${this.dataStore.api.apiUser}:${this.dataStore.api.apiPassword}`)
        }
      })
      .then(res => res.json())
      .then(data => {
        console.log("fetched sda")
          this.sdaList = data
          this.filteredSdaList = this.sdaList
      })

      let url2 = this.$baseUrl+'/api/queues'
      if(this.limitedSda) {
        url2 += '?limitedSda=' + this.limitedSda
      }
      fetch(url2, {
        method: 'GET',
        headers: {
          authorization: 'Basic '+btoa(`${this.dataStore.api.apiUser}:${this.dataStore.api.apiPassword}`)
        }
      })
      .then(res => res.json())
      .then(data => {
        console.log("fetched callgroups")
        this.callGroupList = data
        this.filteredCallGroupList = this.callGroupList
      })
      fetch(this.$baseUrl+'/api/agents', {
        method: 'GET',
        headers: {
          authorization: 'Basic '+btoa(`${this.dataStore.api.apiUser}:${this.dataStore.api.apiPassword}`)
        }
      })
      .then(res => res.json())
      .then(data => {
        console.log("fetched Agents")
        this.agentsList = data
        this.filteredAgentsList = this.agentsList
      })
    },
    formatDate (date) {
      // console.log(date)
      let day0 = date[0]?.getDate() || 'JJ';
      let month0 = date[0]?.getMonth() + 1 || 'MM';
      let year0 = date[0]?.getFullYear() || 'AAAA';

      let day1 = date[1]?.getDate() || 'JJ';
      let month1 = date[1]?.getMonth() + 1 || 'MM';
      let year1 = date[1]?.getFullYear() || 'AAAA';


      //put 0 in front if single-digit
      day0 = (day0!='JJ' && day0<10) ? '0' + day0 : day0;
      month0 = (month0!='MM' && month0<10) ? '0' + month0 : month0;

      day1 = (day1!='JJ' && day1<10) ? '0' + day1 : day1;
      month1 = (month1!='MM' && month1<10) ? '0' + month1 : month1;

      return `${day0 ?? 'JJ'}/${month0 ?? 'MM'}/${year0 ?? 'AAAA'} - ${day1 ?? 'JJ'}/${month1 || 'MM'}/${year1 ?? 'AAAA'}`
    },
    selectSda (sdaName) {
      //refresh data based on sda and give value to selectedsda
      this.selectedSda = sdaName
      this.sdaInputFocused = false;
      this.optionIsClicked = true
      this.sendFilters()
    },
    selectCallGroup (callGroupName) {
      //refresh data based on callGroup and give value to selectedCallGroup
      this.selectedCallGroup = callGroupName
      this.callGroupInputFocused = false;
      this.optionIsClicked = true
      this.sendFilters()
    },
    selectAgent (Agent, contactName) {
      //refresh data based on agent and give value to selectedAgent
      this.selectedAgent = Agent
      this.selectedAgentDisplay = contactName
      this.agentsInputFocused = false;
      this.optionIsClicked = true
      this.sendFilters()
    },
    sendFilters () {
      let filterObject = {
        dates: this.date,
        selectedSda: this.selectedSda,
        selectedCallGroup: this.selectedCallGroup,
        selectedAgent: this.selectedAgent
      }
      console.log('sendFilters', filterObject)
      this.$emit('updateFilters', filterObject)
    },
    handleBlur () {
      setTimeout(() => {
        if(!this.optionIsClicked) {
          setTimeout(() => {
            this.sdaInputFocused = false
            this.callGroupInputFocused = false
            this.agentsInputFocused = false
            this.sendFilters()
          }, 100)
        }
      }, 100)
    }
  },
  mounted () {
    this.getFilterData()
  },
  created () {
    // If start & end dates are set as query params, set them in the date picker
    const urlParams = new URLSearchParams(window.location.search);
    const startDateParam = urlParams.get('startDate')
    const endDateParam = urlParams.get('endDate')
    if(startDateParam && endDateParam) {
      const startDate = new Date(startDateParam)
      const endDate = new Date(endDateParam)
      if(!isNaN(startDate) && !isNaN(endDate)) {
        this.date = [startDate, endDate]
      }
    }
    this.sendFilters()
  }
}
</script>

<style scoped>
/* Hide scrollbar for Chrome, Safari and Opera */
.sideBar::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.sideBar {
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
}
main.sideBar {
  width: 15%;
  min-width: 220px;
  height: 100vh;
  border-right: 1px solid rgba(0, 0, 0, 0.15);
  overflow-y: scroll;
}
.logo-container {
  width: 100%;
  padding: 10px;
}
.filterSelection {
  width: 100%;
  padding: 20px;
}
datalist.sideBar{
  position: absolute;
  background-color: white;
  border: 1px solid rgba(0, 0, 0, 0.15);;
  border-radius: 0 0 5px 5px;
  border-top: none;
  font-family: sans-serif;
  /* width: 100%; */
  width: calc(15% - 40px);
  min-width: 180px;
  padding: 5px;
  max-height: 16rem;
  overflow-y: auto
}

option {
  background-color: white;
  padding: 4px;
  color: black;
  margin-bottom: 1px;
  font-size: 14px;
  cursor: pointer;
}

option:hover, .active{
  background-color: rgba(0, 0, 0, 0.15);
}

input::placeholder{
  font-size: 12px;
}
.navigation-container {
  text-align: left;
  width: 100%;
}

h6 {
  font-size: 0.75rem;
  font-weight: 500;
  line-height: 1.66;
  font-family: "Public Sans", sans-serif;
  color: rgb(140, 140, 140);
  padding: 8px 28px;
}
.link {
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 1.57;
  font-family: "Public Sans", sans-serif;
  color: rgb(38, 38, 38);
  text-decoration: none;
  display: flex;
  justify-content: flex-start;
  gap: 1rem;
  align-items: center;
  width: 100%;
  padding: 12px 28px;
}
.link:hover {
  background-color: rgb(230, 247, 255);
}

.router-link-active {
  border-right: 2px solid rgb(24, 144, 255);
  color: rgb(24, 144, 255);
  background-color: rgb(230, 247, 255);
}
</style>
